import Bar from './bar.js';
import classes from "./about.module.css";
import c from '../../assest/skill/c.png';
import cpp from '../../assest/skill/cpp.png';
import py from '../../assest/skill/py.png';
import js from '../../assest/skill/js.png';
import react from '../../assest/skill/react.png';
import html from '../../assest/skill/cp.png';
import css from '../../assest/skill/css.png';
import nodejs from '../../assest/skill/nodejs.png';
import jquery from '../../assest/skill/jquery.png';
import git from '../../assest/skill/git.png';
import github from '../../assest/skill/github.png';
import { addScaleCorrection, motion } from "framer-motion";
const skill = [
    {
        icon:c,
        name:"C",
        percent:60,
        level:"Intermediaite"
    },{
        icon:cpp,
        name:"C++",
        percent:70,
        level:"Intermediaite"
    },{
        icon:py,
        name:"Python",
        percent:60,
        level:"Beginer"
    },{
        icon:js,
        name:"Javascript",
        percent:60,
        level:"Intermediaite"
    },{
        icon:css,
        name:"CSS",
        percent:"59",
        level:"beginer"
    },{
        icon:nodejs,
        name:"Node.js",
        percent:60,
        level:"Intermediaite"
    }
    ,{
        icon:react,
        name:"React.js",
        percent:60,
        level:"Intermediaite"
    }
]
const tool =[
    {
        icon:git,
        name:"Git",
        percent:"60"
    },{
        icon:github,
        name:"Github",
        percent:"50"
    }
]

const resume = ()=>{
    const ani1 = {
        hidden:{
            y:'4vh',
            opacity:0
        },
        visible:{
            y:0,
            opacity:1,
            transition:{
              delay:0.2,duration:0.6,type:'spring'
            },
            exit:{
                opacity:0.3,
                transition:{
                    ease:'easeInOut'
                }
            }
            
            
      
        }
      }
    const s1 = ["col-lg-6",classes.edu_card];
    return(
        <motion.div className="container resume mt-3" style={{marginTop:"10px"}}
        variants={ani1}
        initial='hidden'
        animate='visible'
        exit='exit'>
        
            <div className="row">
                <div className={s1.join(' ')}>
                     <div className={classes.heading}>
                        <h3>Education</h3>
                     </div>
                     <div className={classes.card_body}>
                         <h6>Madan Mohan Malaviya University of Technolgy,Gorakhpur</h6>
                        <p className={classes.heading}>Computer Science Engenering</p>
                     </div>
                     <p style={{fontSize:"15px"}} >2018-2022</p >
                </div>
                <div className={s1.join(' ')}>
                     <div className={classes.heading}>
                        <h3>Experience</h3>
                     </div>
                     <div className={classes.card_body}>
                         <h6>Student Coordinator</h6>
                        <p className={classes.heading}>Training and Placement Cell,MMMUT</p>
                     </div>
                     <p style={{fontSize:"15px"}} >2020-Present</p >
                </div>
               

            </div>
            <div className="row">
            <div className="col-lg-6 mt-5">
                     <div className={classes.heading}>
                        <h3 style={{borderBottom:"1px solid white"}}>Language & Framework</h3>
                     </div>
                     <div>
                         {
                             skill.map(skills=><Bar key ={skills.name}icon={skills.icon} name ={skills.name}
                                                    per ={skills.percent} level={skills.level} />
                                
                                )
                         }
                         
                     </div>
                    
                </div>
                <div className="col-lg-6 mt-5">
                     <div className={classes.heading}>
                        <h3 style={{borderBottom:"1px solid white"}}>Tools</h3>
                     </div>
                     <div>
                     {
                             tool.map(skills=><Bar key ={skills.name} icon={skills.icon} name ={skills.name}
                                                    per ={skills.percent} />
                                
                                )
                         }
                         
                     </div>
                    
                </div>


            </div>
           
        </motion.div>
    )
}
export default resume;